import { useMemo } from "react";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { usePhaseSelector } from "@/modules/projects/hooks/usePhases";

type Props = {
  projectId: string | null | undefined;
  phaseId: string | null | undefined;
  stageId: string | null | undefined;
  onPhaseChange: (phaseId: string | null) => void;
  onStageChange: (stageId: string | null) => void;
  disabled?: boolean;
};

export function PhaseStagePicker({
  projectId,
  phaseId,
  stageId,
  onPhaseChange,
  onStageChange,
  disabled,
}: Props) {
  const { data } = usePhaseSelector(projectId ?? null);

  const selectedPhase = useMemo(
    () => data?.find((p) => p.id === phaseId) ?? null,
    [data, phaseId],
  );

  if (!projectId) return null;

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Phase</Label>
        <Select
          value={phaseId ?? ""}
          disabled={disabled}
          onChange={(e) => {
            const v = e.target.value || null;
            onPhaseChange(v);
            onStageChange(null);
          }}
        >
          <option value="">No phase</option>
          {data?.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </Select>
      </div>
      <div className="space-y-2">
        <Label>Stage</Label>
        <Select
          value={stageId ?? ""}
          disabled={disabled || !phaseId}
          onChange={(e) => onStageChange(e.target.value || null)}
        >
          <option value="">
            {phaseId ? "No stage" : "Select a phase first"}
          </option>
          {selectedPhase?.stages.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
}
